import { createContext } from 'react'
import type { MetroMapEvent, MetroMapState, Store } from './metroMapStore'

/**
 * Context object only. Kept in its own file (separate from the Provider
 * component and the consumer hooks) so React Fast Refresh can correctly
 * HMR the Provider component in isolation — the
 * `react-refresh/only-export-components` ESLint rule requires that any
 * file which exports a component exports ONLY components.
 *
 * Null when no provider wraps the subtree; consumers throw via
 * `useMetroMapStore` if they try to read state outside a provider.
 */
export const MetroMapStoreContext = createContext<Store<MetroMapState, MetroMapEvent> | null>(null)
